import { EarningMechanismFragment } from '@occc/graphql';

export const earningMechanismTitle: Record<EarningMechanismFragment['__typename'], string> = {
  EarningMechanismExternalFulfillment: 'External Fulfillment',
  EarningMechanismTotalEligiblePurchase: 'Total Eligible Purchase',
  EarningMechanismTotalEligiblePurchaseOverTime: 'Total Eligible Purchase Over Time',
  EarningMechanismProductPurchase: 'Product Purchase',
  EarningMechanismTotalSpendOverTime: 'Total Spend Over Time',
  EarningMechanismVisits: 'Visits',
  EarningMechanismLoyaltyEvent: 'Loyalty Event',
  EarningMechanismMembershipEvent: 'Membership Event',
  EarningMechanismVarietyPurchase: 'Variety Purchase',
  EarningMechanismVarietyPurchaseOverTime: 'Variety Purchase Over Time',
  EarningMechanismPointSpend: 'Point Spend',
  EarningMechanismTransactionDiscount: 'Transaction Discount',
  EarningMechanismProductDiscount: 'Product Discount',
  EarningMechanismVarietyDiscount: 'Variety Discount',
  EarningMechanismTotalSpendOnTransaction: 'Total Spend On Transaction',
  EarningMechanismSpinWheelGame: 'Spin Wheel Game',
  EarningMechanismPromocodes: 'Promo Code',
  EarningMechanismStoredValueDiscount: '', // TODO: Implement EarningMechanismStoredValueDiscount
};

export const awardTitle = {
  AwardVouchers: 'Vouchers',
  AwardPoints: 'Points',
  AwardPointsPer: 'Points per',
  AwardExternalPoints: 'External Points',
  AwardTransactionMoneyDiscount: 'Transaction Money Discount',
  AwardTransactionPercentDiscount: 'Transaction Percent Discount',
  AwardMoneyDiscount: 'Money Discount',
  AwardPriceOverride: 'Price Override',
  AwardBuyAndGet: 'Buy And Get',
  AwardProductDiscount: 'Product Discount',
  AwardExternal: 'External',
};
